import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TDropdownListItem } from '@cynteka/ui-kit';
import { CommonModule } from '@angular/common';

import { ChatSessionItem } from '../../../types/chat-session.types';
import { UiButtonFunctionComponent, UiCountComponent, UiDropdownMenuDirective } from '@cynteka/ui-kit';

export type ChatSessionItemType = 'user' | 'context' | 'agent';

@Component({
    selector: 'chat-session-item',
    standalone: true,
    imports: [CommonModule, UiCountComponent, UiButtonFunctionComponent, UiDropdownMenuDirective],
    templateUrl: './chat-session-item.component.html',
    styleUrls: ['./chat-session-item.component.scss'],
})
export class ChatSessionItemComponent implements OnInit {
    @Input() public session!: ChatSessionItem;
    @Input() public type: ChatSessionItemType = 'user';
    @Input() public active = false;
    @Input() public showAvatar = false;
    @Input() public showOnlineIndicator = false;
    @Input() public showUnreadCount = false;
    @Output() public selected = new EventEmitter<void>();
    @Output() public deleted = new EventEmitter<void>();
    @Input() public menuItems: TDropdownListItem[] = [];

    /** true, когда есть subtitle-блоки. */
    public get hasSubtitles(): boolean {
        return Boolean(this.session.subtitles?.length);
    }

    /** Текст последнего сообщения/файла для caption-строки. */
    public get captionText(): string | null {
        return this.session.lastMessageFile || this.session.lastMessage || null;
    }

    /** true, когда нужно показывать счётчик непрочитанных. */
    public get showUnreadBadge(): boolean {
        return this.showUnreadCount && this.session.unreadCount > 0;
    }

    public get initials(): string {
        return this.session.title
            .split(' ')
            .map(w => w[0] ?? '')
            .join('')
            .slice(0, 2)
            .toUpperCase();
    }
    public resolvedMenuItems: TDropdownListItem[] = [];

    public ngOnInit(): void {
        this.resolvedMenuItems = this.menuItems;
    }
}
